type PropsT = {
  className?: string
  strokeColor?: string
}

// Outline speech-bubble with a slash ("no messages"). Path mirrors the restrict-customer modal's "What this means" rows
// (Sketch order-feedback-landing-page v83 `.rst-row svg`).
const ChatBubbleSlash = (props: PropsT) => {
  const { className, strokeColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="chat-bubble-slash-icon"
    >
      <path d="M21 15V5a2 2 0 0 0-2-2H9" />
      <path d="M3.6 3.6A2 2 0 0 0 3 5v16l4-4h10a2 2 0 0 0 1.4-.6" />
      <path d="m2 2 20 20" />
    </svg>
  )
}

export default ChatBubbleSlash
